/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/catalog/item_error_count" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCountResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCountResult } from "./validators";

export const getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount,
  (
    signal: AbortSignal,
    appGroupId: string,
    bridgeId: string
  ): Promise<AlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCountResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}/catalog/item_error_count`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCountResult
);
